import React, { useEffect, useState } from "react";
import CancelDeleteModal from "./CancelDeleteModal";
import { useStateProvider } from "../common/StateProvider";
import { todayWorkflowReconnectData } from "../common/Helper";
import { DateRangeIcon } from "../common/Icon";
import MarkCompletedModal from "./MarkCompletedModal";
import TodayWorkflowItemProfile from "./TodayWorkflowItemProfile";

const ReconnectsItem = () => {
  const {
    setTodaysWorkflowProfile,
    setTodaysWorkflowIndex,
    setTodayWorkflowUpdate,
  } = useStateProvider(); // Get Profile
  const { profileItemPage, setProfileItemPage } = useStateProvider(); //TODAY WORKFLOW ITEM PROFILE PAGE

  const { deleteModal, setDeleteModal } = useStateProvider();
  const { deletModalHeading, setdeletModalHeading } = useStateProvider();
  const { markModal, setmarkModal } = useStateProvider(); //Mark Complete MODEL
  const { markCompleteModalHeading, setmarkCompleteModalHeading } =
    useStateProvider(); //Mark Complete MODEL HEADING
  const [todayWorkflowContactArray, setTodayWorkflowContactArray] = useState([
    ...todayWorkflowReconnectData, // Use the spread operator to create a copy of the array
  ]);
  const [deleteItemIndex, setDeleteItemIndex] = useState(null);

  // Function to show the Productivity modal
  const opendeleteModal = (value, index) => {
    setDeleteModal(true);
    setdeletModalHeading(value.reconnectModeltext);
    setDeleteItemIndex(index); // Store the index
  };

  // Function to show the Mark Complete MODEL
  const openMarkCompleteModel = (value) => {
    setmarkModal(true);
    setmarkCompleteModalHeading(value.markCompletedModelHeading);
  };

  const deleteCard = () => {
    if (deleteItemIndex !== null) {
      const updatedData = [...todayWorkflowContactArray];
      updatedData.splice(deleteItemIndex, 1);
      setTodayWorkflowContactArray(updatedData);
      setDeleteModal(false); // Close the modal after deletion
    }
  };

  // Function to show the Today Workflow Item Profile Page
  const openProfileItemPage = (value, index) => {
    setProfileItemPage(true);
    setTodaysWorkflowProfile(value);
    setTodaysWorkflowIndex(index);
    setTodayWorkflowUpdate(todayWorkflowContactArray);
  };

  // OVERLAY BEHIND FILTER MODEL
  const overLayHidden = () => {
    setProfileItemPage(!profileItemPage);
  };

  // OVERFLOW HIDDEN WHEN FILTER MODEL OPEN
  useEffect(() => {
    if (profileItemPage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [profileItemPage]);
  return (
    <>
      <div className="w-[600px] xm:w-[700px] md:w-auto overflow-x-auto">
        {todayWorkflowContactArray.map((value, index) => (
          <div
            className=" p-[7px_10px] rounded-md border-[0.2px] border-solid border-black/10 bg-white hover:shadow-workflow_item_card_shadow duration-300 cursor-pointer mb-2"
            key={index}>
            <div className="flex items-center justify-between">
              <div
                onClick={() => openProfileItemPage(value, index)}
                className="flex items-center gap-4 w-full">
                <img src={value.newContactImg} alt="teams" />
                <div>
                  <div className=" flex items-center gap-4 ">
                    <h5 className="text-sm 3xl:text-[16px] font-normal text-black">
                      {value.newContactNameText}
                    </h5>
                    <div className="flex gap-1">
                      <span>{value.reconnectStatusIcon}</span>
                      <p
                        className={`${value.reconnectLevelTextColor} text-xs 3xl:text-[14px] font-normal pr-1`}>
                        {value.reconnectLevelText}
                      </p>
                    </div>
                    <div className=" flex items-center gap-1">
                      <span>
                        <DateRangeIcon />
                      </span>
                      <p className="text-[10px] 3xl:text-[12px] font-normal text-gray">
                        {value.reconnectFullDate}
                      </p>
                    </div>
                    <p
                      className={` ${value.reconnectLabelBtnBgColor} text-[8px] 3xl:text-[11px] font-bold text-white p-[4px_10px] rounded-[38px] `}>
                      {value.reconnectLabelBtn}
                    </p>
                  </div>
                </div>
              </div>
              <div className=" flex items-center gap-[6px]">
                <button
                  onClick={() => openMarkCompleteModel(value)}
                  className="text-[10px]  3xl:text-[12px] w-[115px] 3xl:w-[130px] font-semibold text-gray p-[5px_6px] rounded border-[0.851px] border-solid border-[rgba(0,_0,_0,_0.20)] flex items-center gap-1 hover:bg-primary hover:text-white hover:border-transparent duration-200 markComplete-btn">
                  <span className="markCompleteIcon-icon">
                    {value.markCompleteIcon}
                  </span>
                  {value.markCompleteBtn}
                </button>
                <span onClick={() => opendeleteModal(value, index)}>
                  {value.deleteWorkflowIcon}
                </span>
                <span onClick={() => openProfileItemPage(value, index)}>
                  {value.rightArrow}
                </span>
              </div>
            </div>
          </div>
        ))}
        {/* DELETE MODAL HEADING */}
        {deleteModal && (
          <CancelDeleteModal
            deleteModal={deleteModal}
            setDeleteModal={setDeleteModal}
            deletModalHeading={deletModalHeading}
            deleteCard={deleteCard}
          />
        )}
        {/* Mark Complete MODAL */}
        {markModal && (
          <MarkCompletedModal
            markModal={markModal}
            setmarkModal={setmarkModal}
            markCompleteModalHeading={markCompleteModalHeading}
          />
        )}

        <div className="fixed right-0 md:right-4 top-0 z-30">
          {profileItemPage && (
            <TodayWorkflowItemProfile
              setProfileToggle={setProfileItemPage}
              setProfileItemPage={openProfileItemPage}
            />
          )}
        </div>
        <div
          onClick={overLayHidden}
          className={` fixed inset-0 min-h-full z-20  bg-black opacity-10 ${
            profileItemPage ? "w-[100%] " : "hidden"
          }`}></div>
      </div>
    </>
  );
};

export default ReconnectsItem;
